'use strict';
import DTRelay from '@expressive-analytics/dtrelay'
import Local from 'config/local'
const relay = new DTRelay("Relay",Local.relays.Relay)
export default relay
